
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import LeadWorkflowTasks from '@/components/LeadWorkflowTasks.vue';
import LeadWorkflowDetails from '@/components/LeadWorkflowDetails.vue';
import LeadAddChildDialog from '@/components/LeadAddChildDialog.vue';
import LeadCreateChildDialog from '@/components/LeadCreateChildDialog.vue';
import LeadChecklists from '@/components/LeadChecklists.vue';
import {
  Checklist, Lead, LeadStatus, PermissionCode, User,
} from '@/types';

@Component({
  components: {
    LeadWorkflowTasks,
    LeadWorkflowDetails,
    LeadAddChildDialog,
    LeadCreateChildDialog,
    LeadChecklists,
  },
})
export default class LeadWorkflow extends Vue {
  @Prop(Boolean) readonly loading!: boolean

  addChildDialog = false

  createChildDialog = false

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get status(): LeadStatus {
    return this.lead.status;
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  get canAddChild() {
    return this.lead
      && this.status === 'open'
      && this.hasPermission(`leads_${this.lead.type}.task_child`)
      && ['standard', 'configuratore', 'ordine', 'richiesta'].includes(this.lead.type);
  }

  get checklists(): Checklist[] {
    return this.lead && Array.isArray(this.lead.checklists) && this.lead.checklists.length > 0
      ? this.lead.checklists
      : [];
  }

  get hasChecklists(): boolean {
    return this.checklists.length > 0;
  }

  hasPermission(codename: PermissionCode) {
    // console.log(`App: hasPermission(${codename})`); // eslint-disable-line no-console

    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  onAddChild() {
    console.log('LeadWorkflow: onAddChild()'); // eslint-disable-line no-console

    this.addChildDialog = true;
  }

  onCreateChild() {
    console.log('LeadWorkflow: onCreateChild()'); // eslint-disable-line no-console

    this.createChildDialog = true;
  }

  onGoto(where: string) {
    console.log('LeadWorkflow: onGoto() where =', where); // eslint-disable-line no-console

    this.$emit('goto', where);
  }
}
